import { makeStyles, Theme } from '@material-ui/core';

export const useWalletStyles = makeStyles<Theme>(theme => ({
  accountBtn: {
    color: '#1B1B1B',
    padding: '0 14px',
    border: '1px solid #333',
    height: '40px',
    background: '#fff',
    minWidth: 'auto',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: 600,
    boxShadow: '3px 3px 0px 0px #D2D2F9',
    transition: 'box-shadow 0.15s, transform 0.15s',
    '&:before': {
      display: 'none',
    },
    '&:hover': {
      background: '#fff',
      boxShadow: 'none',
      transform: 'translate(3px, 3px)',
    },
    '& img': {
      width: '18px',
      marginRight: '7px',
      opacity: 0.6,
      [theme.breakpoints.down(576)]: {
        width: '16px',
        marginRight: '4px',
      },
    },
    [theme.breakpoints.down(576)]: {
      height: '36px',
      padding: '0 10px',
      fontSize: '12px',
    },
  },

  accountBtnMd: {
    marginBottom: theme.spacing(2.5),
  },

  walletLogo: {
    width: 44,
    height: 44,
    marginLeft: theme.spacing(1.5),
    borderRadius: '50%',
  },

  dropdown: {
    width: 220,
    position: 'absolute',
    zIndex: theme.zIndex.tooltip,
    top: `calc(100% + ${theme.spacing(1)}px)`,
    right: 0,

    pointerEvents: 'none',
    opacity: 0,
    transform: `translateY(${theme.spacing(-1)}px)`,
    transition: 'opacity 0.2s, transform 0.2s',
  },

  dropdownActive: {
    opacity: 1,
    transform: 'translateY(0)',
    pointerEvents: 'auto',
  },
  connectIcon:{
    height:'28px',
    marginRight:'10px',
  },
  switch:{
    marginRight:'6px',
    height:'46px',
    borderRadius:'23px',
    border:'1px solid #B6BED0',
    backgroundColor:'#fff',
    color:'#393939',
    fontSize:'15px',
    lineHeight:'25px',
    display:'flex',
    '& img':{
      marginLeft:'10px',
      [theme.breakpoints.down(576)]: {
        marginLeft:'4px',
        width:'14px'
      },
    },
    '&:hover': {
      backgroundColor:'#fff',
      opacity:0.8
    },
    [theme.breakpoints.down(576)]: {
      height: '40px',
      borderRadius:'20px',
      padding:'0 16px',
      fontSize:'13px',
    },
  }
}));
